<template>
  <page-tab
    :banner="banner"
    :breadcrumb="breadcrumb"
    :tabList="tabList"
    v-model="tabCurrent"
    @change="tabChange"
  >
    <div class="news-list">
      <div
        class="item"
        v-for="(item, i) in list"
        :key="i"
        @click="toDetail(item.id)"
      >
        <img class="image" :src="item.icon" />
        <div class="item-content">
          <div class="name">{{ item.title }}</div>
          <div class="subName">{{ item.mark }}</div>
          <!-- <div class="time">
            <el-tag type="success" effect="plain" size="small">标签一</el-tag
            ><el-tag type="success" effect="plain" size="small">标签二</el-tag>
          </div> -->
          <p>{{ item.summary }}</p>
        </div>
      </div>
    </div>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />
    <el-empty description="暂无数据" v-show="total < 1"></el-empty>
  </page-tab>
</template>
<script>
import PageTab from "@/components/PageTab.vue";
import banner from "@/assets/images/banner/system.png";
import { getServiceList, getPageServiceItems } from "@/api/index";

export default {
  name: "System",
  components: {
    PageTab,
  },
  data() {
    return {
      banner,
      breadcrumb: [
        { name: "首页", path: "/" },
        { name: "客户服务", path: "" },
        { name: "", path: "" },
      ],
      list: [],
      tabList: [],
      tabCurrent: "",
      queryParams: {
        pageNum: 1,
        pageSize: 2,
      },
      total: 0,
    };
  },
  created() {
    this.getServiceList();
  },
  methods: {
    tabChange(item) {
      this.breadcrumb[2].name = item.name;
      this.queryParams.pageNum = 1;
      this.getList();
    },
    getServiceList() {
      getServiceList().then((res) => {
        this.tabList = res.data;
        this.tabCurrent = this.tabList[0].id;
        this.getList();
      });
    },
    getList() {
      const params = {
        ...this.queryParams,
        serviceId: this.tabCurrent,
      };
      getPageServiceItems(params).then((res) => {
        this.list = res.rows;
        this.total = res.total;
      });
    },
    toDetail(id) {
      this.$router.push(`/systemDetail?id=${id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss"; // global css
.news-list {
  .item {
    background: #ffffff;
    display: flex;
    margin-bottom: 60px;
    .image {
      display: block;
      width: 313px;
      height: 186px;
      object-fit: cover;
      border-radius: 2px;
      transition: all 0.5s;
      &:hover {
        transform: scale(1.02);
      }
    }
    .item-content {
      flex: 1;
      padding: 12px 20px 5px 50px;
      font-size: 14px;
      color: #333333;
      line-height: 1;
      cursor: pointer;
      &:hover {
        .name {
          text-decoration: underline;
          color: $main-color;
        }
      }
      .name {
        font-size: 18px;
        font-weight: bold;
        // @include clamp(1);
      }
      .subName {
        font-size: 16px;
        color: #666;
        margin-top: 14px;
      }
      .time {
        margin-top: 14px;
        color: #999;
      }
      .el-tag {
        margin-right: 10px;
      }
      p {
        line-height: 2;
        margin-top: 20px;
        // @include clamp(3);
      }
    }
  }
}
.isMobile {
  .news-list {
    .item {
      display: block;
      margin-bottom: 20px;
      border-bottom: 1px solid #eee;
      .image {
        width: 100%;
        height: 120px;
      }
      .item-content {
        padding: 12px;
      }
    }
  }
}
</style>
